<template>
  <!-- eslint-disable -->
  <v-dialog v-model="show" max-width="800px" persistent>
    <v-card>
      <v-card-title>
        <h3>Client Email</h3>
      </v-card-title>
      <quill-editor ref="myTextEditor" v-model="emailBody" class="quill-editor" :options="editorOption">
      </quill-editor>
      <v-card-text></v-card-text>
      <v-card-actions>
        <v-btn color="primary" class="client-email-close-btn" text @click.stop="show=false">Close</v-btn>
        <v-btn color="primary" class="client-email-send-btn" :disabled="sending" text @click.stop="sendRequest()">Send</v-btn>
        <v-progress-circular v-show="sending" indeterminate color="primary"></v-progress-circular>
      </v-card-actions>
    </v-card>
  </v-dialog>
<!-- eslint-enable -->
</template>
<script>
import { quillEditor } from "vue-quill-editor";
import { mapGetters } from "vuex";
import { CALAMITY_NAMESPACE } from "./store/calamityStore";
export default {
  name: "ClientEmail",
  components: {
    quillEditor
  },
  data() {
    return {
      sending: false,
      emailTemplate:
        "Team, <br />The attached shipments have been delayed in transit.",
      emailBody:
        "Team, <br />The attached shipments have been delayed in transit.",
      show: false,
      calamityId: null,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline"],
            ["blockquote"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"]
          ]
        }
      }
    };
  },
  computed: {
    ...mapGetters(CALAMITY_NAMESPACE, ["carrierRequestPackages", "loading"])
  },
  created: /* istanbul ignore next */ function() {
    this.$parent.$on("clientEmail", this.showDialog);
  },
  methods: {
    sendRequest() {
      this.sending = true;
      return this.$store
        .dispatch(`${CALAMITY_NAMESPACE}/SEND_CLIENT_EMAIL`, {
          calamityId: this.calamityId,
          emailBody: this.emailBody
        })
        .then(res => {
          this.calamityId = null;
          this.show = false;
          this.emailBody = this.emailTemplate;
          this.sending = false;
          this.$store.dispatch(`${CALAMITY_NAMESPACE}/LOAD`);
        })
        .catch(
          /* istanbul ignore next */ () => {
            this.sending = false;
          }
        );
    },
    showDialog(payload) {
      this.calamityId = payload.calamityId;
      this.show = true;
    }
  }
};
</script>
